/* eslint-disable react/no-danger */
import React from "react";

import { Collapse } from "@material-ui/core";

import { HvTypography } from "@hitachivantara/uikit-react-core";

import { NotificationTemplate } from "lib/api/notificationtemplate";

import useStyles from "./styles";

export interface TemplatePreviewProps {
  visible?: boolean;
  scroll?: boolean;
  template?: NotificationTemplate;
  title: string;
  subjectLabel?: string;
  contentLabel?: string;
}

const TemplatePreview: React.FC<TemplatePreviewProps> = ({
  visible = false,
  scroll = true,
  template,
  title,
  subjectLabel,
  contentLabel,
}) => {
  const classes = useStyles();

  const preventKeyboardInteraction: React.KeyboardEventHandler<HTMLDivElement> =
    (e) => {
      if (e.key === "Tab") {
        // allow tab key to escape out
        return true;
      }

      e.preventDefault();
      e.stopPropagation();

      return true;
    };

  return (
    <Collapse
      in={visible}
      appear={visible}
      onEnter={(element) => {
        if (scroll) {
          element.scrollIntoView({ behavior: "smooth", block: "end" });
        }
      }}
      onEntered={(element) => {
        if (scroll) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }}
      mountOnEnter
      unmountOnExit
    >
      {template != null && (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
          className={classes.previewArea}
          onKeyDown={preventKeyboardInteraction}
        >
          <HvTypography variant="highlightText" component="h3">
            {title}
          </HvTypography>
          {template.subject != null && (
            <div>
              {subjectLabel != null && (
                <HvTypography variant="highlightText" component="span">
                  {subjectLabel}:&nbsp;
                </HvTypography>
              )}
              <span>{template.subject}</span>
            </div>
          )}
          {template.content != null && (
            <div>
              {contentLabel != null && (
                <HvTypography variant="highlightText" component="div">
                  {contentLabel}:
                </HvTypography>
              )}
              <div dangerouslySetInnerHTML={{ __html: template.content }} />
            </div>
          )}
        </div>
      )}
    </Collapse>
  );
};

export default TemplatePreview;
